 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		56: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "js/bundle." + ({"0":"e-invoice","1":"outlet","2":"index","3":"supplier","4":"myaccount","5":"stock-check-create","6":"stock-return-create","7":"stock-receive-edit","8":"dashboard-index","9":"stock-return","10":"stock-receive","11":"stock-check","12":"stock-receive-create","13":"promotion-detail","14":"batcave-franchise-detail","15":"staff-index","16":"loyalty-redemption","17":"batcave-franchise-index","18":"user-index","19":"stock-index","20":"role-index","21":"stock-cost-index","22":"profile-index","23":"billing-index","24":"stock-return-index","25":"stock-receive-index","26":"stock-check-index","27":"stock-return-edit","28":"stock-check-edit","29":"monitor-index","30":"batcave-master-index","31":"promotion-index","33":"measurement-index","34":"access-token-list","35":"loyalty-settings","36":"audit-trail-index","37":"stock-fifo-index","38":"purchase-index","39":"fnb-stock-return-index","40":"fnb-stock-receive-index","41":"fnb-stock-check-index","42":"fnb-supplier-index","43":"supplier-index","44":"customer-detail","45":"customer-index","46":"fnb-sync-index","47":"sync-index","48":"new-sync-index","49":"promotion-report-table"}[chunkId]||chunkId) + "." + {"0":"fa45b852b2d535667643","1":"a2902425f9cdb50cd62f","2":"58a549753401f206bec0","3":"2be8099717f7a579020d","4":"60757421096a05b84489","5":"042e19b79489492a1644","6":"b490c141e388104463c2","7":"89488769c693eb2a6ab0","8":"40a825b252ee874b8770","9":"fff5457e03402d357acb","10":"972450f53a516ece7d8b","11":"ffbf7319f8e55ade2dc7","12":"dd86d01c847efe0a7736","13":"bb44deaec5d5e272c85e","14":"4c0bd15fdf6b0ee48144","15":"93a2fa1a675a582a6dd3","16":"1ec9747a4e748ba2b2d7","17":"55050e7a6ccb1ab75e62","18":"14afc423ee95508e9c60","19":"eea5b4eeb6633aecf4a7","20":"f0d7c86a51fcd4f29f12","21":"1e74c5c8c431417929ae","22":"286373c88bbbfad5085d","23":"53f636ca95688220f135","24":"1624be67c91802689459","25":"36e26e2a1a585ef5240e","26":"b5bef9485df737c8751b","27":"9822034540af2e874fdb","28":"5399cb8d18ae273a77a4","29":"a7f639e28779973ff49a","30":"a37c3f5f390e8bc6646b","31":"e82f1ba578c3ad14ddae","32":"d60d5142a6c2e89524ac","33":"9f27e1c7f005b31c470c","34":"74e3444fc3566eeaa784","35":"d72d1e8747de1b4b4e47","36":"f4647d1a58d5522444ff","37":"441d85149fc13933844a","38":"659e5d46bc63a487d3f0","39":"a4f169513d4092d0d33f","40":"3c2ce5c5e64e6b043943","41":"821a405dbde56b055f70","42":"5d445bc16c211def2233","43":"10f243d2ec2d916ea639","44":"18897ce1f3793fa771e8","45":"32f9f0ddbebcb2c2afb3","46":"a2c2424d62a78c699d32","47":"31fd68dae6e5ab906d75","48":"0bab377fff34006b6e73","49":"8d6d340c25353c4d35fa"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap ae0bfa70388d474a4226